module.exports = __webpack_public_path__ + "images/create-first-board/card-drag.a2c2b2b56c8471d9309c.gif";


//////////////////
// WEBPACK FOOTER
// ./resources/images/create-first-board/card-drag.gif
// module id = qzu+
// module chunks = 13